module.exports = __webpack_public_path__ + "static/media/DocBrowser_cockpit.cecc1a5b.png";